import { AdjustmentsIcon } from '@heroicons/react/solid'
import { Menu, Transition } from '@headlessui/react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Fragment, useEffect, useState } from 'react'
import HttpService from '../services/HttpService'
import { Badge, Button, Card, EmptyState, Page, Select } from './ui'

const statusStyles = {
    1: 'success',
    '-1': 'warning',
    4: 'neutral',
    2: 'danger',
}

const statusNames = {
    1: 'Pagado',
    '-1': 'Pendiente',
    4: 'Pospuesto',
    2: 'Rechazado',
}

const tipoCodi = [
    { id: '0', nombre: 'Todo' },
    { id: 'QR', nombre: 'QR' },
    { id: 'MESSAGE', nombre: 'MESSAGE' },
]

const estados = [
    { id: '0', nombre: 'Todo' },
    { id: '-1', nombre: 'Pendiente' },
    { id: '1', nombre: 'Pagado' },
    { id: '4', nombre: 'Pospuesto' },
    { id: '2', nombre: 'Rechazado' },
]

export default function Transactions(props) {
    const [transactions, setTransactions] = useState([])
    const [canales, setCanales] = useState([])
    const [cuentas, setCuentas] = useState([])
    const [metadata, setMetadata] = useState([])
    const [selectedFields, setSelectedFields] = useState([])
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [canalSelected, setCanalSelected] = useState({})
    const [cuentaSelected, setCuentaSelected] = useState({})
    const [tipoSelected, setTipoSelected] = useState(tipoCodi[0])
    const [estadoSelected, setEstadoSelected] = useState(estados[0])

    useEffect(() => {
        props.handleTitulo('Transacciones')
        getTransacciones()
        getCatalogos()
    }, [])

    const getCatalogos = () => {
        HttpService.getAxiosClient().get('/catalogos/canales').then((res) => {
            setCanales(res.data.canales)
            setCuentas(res.data.cuentas)
        })
    }

    const getTransacciones = () => {
        const customs = []
        var params = {}
        if (estadoSelected.id !== '0') params.resultadoMensajeCobro = estadoSelected.id
        if (tipoSelected.id !== '0') params.tipoCodi = tipoSelected.nombre
        HttpService.getAxiosClient().get('/transacciones', { params }).then((res) => {
            setTransactions(res.data)
            res.data.map((transaction) => {
                Object.keys(transaction.metadata || {}).map((custom) => {
                    if (!customs.includes(custom)) customs.push(custom)
                })
            })
            setMetadata(customs)
        })
    }

    return (
        <Page
            description="Consulta y filtra las operaciones CoDi de tu empresa."
        >
            <Card className="p-5">
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-700">Fecha inicio</label>
                        <div className="mt-1.5">
                            <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText="Seleccionar" />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-700">Fecha fin</label>
                        <div className="mt-1.5">
                            <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} placeholderText="Seleccionar" />
                        </div>
                    </div>
                    <Select label="Canal" value={canalSelected} onChange={setCanalSelected} options={canales} />
                    <Select label="Cuenta" value={cuentaSelected} onChange={setCuentaSelected} options={cuentas} />
                    <Select label="Estado" value={estadoSelected} onChange={setEstadoSelected} options={estados} />
                    <Select label="Tipo de CoDi" value={tipoSelected} onChange={setTipoSelected} options={tipoCodi} />
                </div>
                <div className="mt-4 flex items-center justify-between">
                    <Button onClick={getTransacciones}>Buscar</Button>
                    <Menu as="div" className="relative">
                        <Menu.Button className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50">
                            <AdjustmentsIcon className="h-5 w-5" />
                            Columnas
                        </Menu.Button>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 z-20 mt-2 w-56 origin-top-right rounded-xl bg-white p-2 shadow-lg ring-1 ring-black/5">
                                {metadata.length === 0 && <p className="px-2 py-1 text-xs text-slate-500">Sin metadatos</p>}
                                {metadata.map((customField) => (
                                    <label key={customField} className="flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm text-slate-700 hover:bg-slate-50">
                                        <input
                                            type="checkbox"
                                            className="rounded border-slate-300 text-brand-600 focus:ring-brand-500"
                                            id={customField}
                                            value={customField}
                                            checked={selectedFields.includes(customField)}
                                            onChange={(e) =>
                                                setSelectedFields(
                                                    e.target.checked
                                                        ? [...selectedFields, customField]
                                                        : selectedFields.filter((p) => p !== customField)
                                                )
                                            }
                                        />
                                        {customField}
                                    </label>
                                ))}
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
            </Card>

            <Card className="mt-6 overflow-hidden">
                {transactions.length === 0 ? (
                    <EmptyState title="No hay transacciones" description="Ajusta los filtros y vuelve a buscar." />
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-slate-100 text-sm">
                            <thead className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                                <tr>
                                    <th className="whitespace-nowrap px-4 py-3">ID</th>
                                    {metadata.map((customField) =>
                                        selectedFields.includes(customField) ? (
                                            <th key={customField} className="whitespace-nowrap px-4 py-3">
                                                {customField}
                                            </th>
                                        ) : null
                                    )}
                                    <th className="whitespace-nowrap px-4 py-3">Canal</th>
                                    <th className="whitespace-nowrap px-4 py-3">Tipo</th>
                                    <th className="whitespace-nowrap px-4 py-3">Celular</th>
                                    <th className="whitespace-nowrap px-4 py-3 text-right">Solicitud</th>
                                    <th className="whitespace-nowrap px-4 py-3 text-right">Procesamiento</th>
                                    <th className="whitespace-nowrap px-4 py-3 text-right">Monto</th>
                                    <th className="whitespace-nowrap px-4 py-3">Estado</th>
                                    <th className="whitespace-nowrap px-4 py-3">Conciliado</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {transactions.map((transaction) => (
                                    <tr key={transaction.id} className="hover:bg-slate-50/80">
                                        <td className="whitespace-nowrap px-4 py-3 font-mono text-xs text-slate-500">
                                            {transaction.id}
                                        </td>
                                        {metadata.map((customField) =>
                                            selectedFields.includes(customField) ? (
                                                <td key={customField} className="whitespace-nowrap px-4 py-3 text-slate-600">
                                                    {transaction.metadata[customField]}
                                                </td>
                                            ) : null
                                        )}
                                        <td className="whitespace-nowrap px-4 py-3 text-slate-700">{transaction.nombreCanal}</td>
                                        <td className="whitespace-nowrap px-4 py-3 text-slate-500">{transaction.tipoCodi}</td>
                                        <td className="whitespace-nowrap px-4 py-3 text-slate-500">{transaction.celular}</td>
                                        <td className="whitespace-nowrap px-4 py-3 text-right text-slate-500">{transaction.fechaHora}</td>
                                        <td className="whitespace-nowrap px-4 py-3 text-right text-slate-500">
                                            {transaction.fechaHoraProcesamiento ? transaction.fechaHoraProcesamiento : ''}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-right font-semibold text-slate-900">
                                            {transaction.monto.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
                                            <span className="text-xs font-normal text-slate-400">MXN</span>
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3">
                                            <Badge tone={statusStyles[transaction.estado] || 'neutral'}>
                                                {statusNames[transaction.estado]}
                                            </Badge>
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-slate-500">{transaction.conciliado}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Card>
        </Page>
    )
}
